export const filterChinese = (value: string): string => value.replace(/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/g, "")

export const validatePassword = (value: string): "length" | "composition" | null => {
  if (value.length < 8 || value.length > 20) return "length"
  if (/\s/.test(value)) return "composition"
  const kinds = [/[A-Z]/, /[a-z]/, /\d/, /[^A-Za-z0-9\s]/].filter((rule) => rule.test(value)).length
  return kinds >= 3 ? null : "composition"
}

const EMAIL_PATTERN =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/

export const isEmail = (value: string): boolean => value.length <= 320 && EMAIL_PATTERN.test(value)
